import React, { useState, useEffect } from 'react'
import Select from '../../../components/Select/Select'
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Button from "@mui/material/Button";
import Axios from "axios";
import { API_URL_USER, API_URL_ADMIN, API_URL_VPS, API_URL_OMS, API_URL_AMS } from "../../../Constant/index";

const AdminRoles = () => {
    const [selectedRole, setSelectedRole] = useState("Select")
    const [role, setRole] = useState("SCCC - CIPI Admin");
    const [userResponse, setUserResponse] = useState([]);
    // const roles = ["Select", "CIPI ADMIN", "WE CARE SUPPORT", "CSC Support"]
    const roles = ["Select", "SCCC - CIPI Admin", "SCCC - WeCare Support", "SCCC - CSC Support", "SCCC - Loyalty Admin", "SCCC - Logistic Admin", "SCCC - CCAR Admin", "SCCC - Pricing Admin", "SCCC - Analyst Admin", "SCCC - Sales Co Admin", "CW - CSC Support", "CW - Pricing Admin", "CW - Sales Co Admin", "SCCO - Admin"]
    const users = ["User 1", "User 2", "User 3", "User 4", "User 5", "User 6", "User 7", "User 8", "User 9", "User 10"]

    const handleChange = (e) => {
        console.log("Role =>", e.target.value)
        setSelectedRole(e.target.value)
    }

    const permissionOnChange = (e) => {
        setRole(e.target.value);
        Axios({
            method: "GET",
            url: API_URL_USER + `ums/resources/role-permissions?role=${e.target.value}`,
            headers: {
                "Content-Type": "application/json",
                "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
                "X-SOLD-TO-ID": "ADMIN USER",
            },
        })
            .then(async (response) => {
                setUserResponse(response.data)
            })
            .catch((err) => {
                // setExportState({ btnName: "EXPORT" });
            });
    };


    useEffect(() => {
        Axios({
            method: "GET",
            url: API_URL_USER + `ums/resources/role-permissions?role=SCCC - CIPI Admin`,
            headers: {
                "Content-Type": "application/json",
                "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
                "X-SOLD-TO-ID": "ADMIN USER",
            },
        })
            .then(async (response) => {
                setUserResponse(response.data)
                console.log("USERRRRRRRR ->", response.data)
            })
            .catch((err) => {
                // setExportState({ btnName: "EXPORT" });
            });

    }, [])


    console.log("userResponse=>", userResponse)
    function caps2Spaces(str) {
        let updatedStr = str ? str.split("").map((s) => (/[A-Z]/.test(s) ? ` ${s.toLowerCase()}` : s)).join("") : "";
        return updatedStr
    }


    return (
        <div className='card mt-1  mb-5'>

            <div className='row p-2'>
                <div className='col-12 col-sm-6 col-md-4'>
                    <Select
                        label={"Roles"}
                        options={roles}
                        minWidth="100%"
                        value={role}
                        onChange={permissionOnChange}
                    />
                </div>
            </div>

            {/* {selectedRole !== "Select" && */}
            <>
                {/*   <div className='row p-2'>
                        <div className='col-12'>
                            Users
                        </div>
                    </div>

                    <div className='row p-2'>
                        {users.map((item, index)=>
                        <div className='col-12 col-sm-6 col-md-3'>
                        <p className={`border rounded p-1 ${index%2 ===0 ? "bg-light":""}`}>
                        {selectedRole +" " + item}
                        </p>
                    </div>
                        )}
                                          
                    </div> */}

                {userResponse.length>0 ?
                <table class="table table-bordered rolesStyle">
                    <tbody>
                        <tr className='roleOptions'>
                            <td colspan="3"></td>
                            <td>View</td>
                            <td>Create</td>
                            <td>Edit</td>
                            <td>Delete</td>
                        </tr>
                        {/* ======================================== */}

                        {userResponse.length > 0 && userResponse.map((item, index) => {
                            return (
                                <>
                                    <tr>
                                        <td colspan="7" className='role_module text-capitalize'>{caps2Spaces(item.parentScreen)}</td>
                                    </tr>
                                    {item.childScreensList && item.childScreensList.length > 0 && item.childScreensList.map((childItem, childindex) => {
                                        var isCreate = item.childScreensList.every(obj => obj.create === true);
                                        var isEdit = item.childScreensList.every(obj => obj.edit === true);
                                        var isView = item.childScreensList.every(obj => obj.view === true);
                                        var isDelete = item.childScreensList.every(obj => obj.delete === true);
                                        return (
                                            <>
                                                <tr>
                                                    <td></td>
                                                    <td className='text-capitalize'>{caps2Spaces(childItem.childScreen)}</td>
                                                    <td></td>
                                                    <td>
                                                        <FormControlLabel control={<Checkbox disabled defaultChecked={isView} />} />
                                                    </td>
                                                    <td>
                                                        <FormControlLabel control={<Checkbox disabled defaultChecked={isCreate} />} />
                                                    </td>
                                                    <td>
                                                        <FormControlLabel control={<Checkbox disabled defaultChecked={isEdit} />} />
                                                    </td>
                                                    <td>
                                                        <FormControlLabel control={<Checkbox disabled defaultChecked={isDelete} />} />
                                                    </td>
                                                </tr>
                                                {childItem.actionButtonsList && childItem.actionButtonsList.length > 0 && childItem.actionButtonsList.map((actionItem, actionIndex) =>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td className='text-capitalize'>{caps2Spaces(actionItem.actionButton)}</td>
                                                        <td>
                                                            <FormControlLabel control={<Checkbox disabled defaultChecked={actionItem.view} />} />
                                                        </td>
                                                        <td>
                                                            <FormControlLabel control={<Checkbox disabled defaultChecked={actionItem.create} />} />
                                                        </td>
                                                        <td>
                                                            <FormControlLabel control={<Checkbox disabled defaultChecked={actionItem.edit} />} />
                                                        </td>
                                                        <td>
                                                            <FormControlLabel control={<Checkbox disabled defaultChecked={actionItem.delete} />} />
                                                        </td>
                                                    </tr>
                                                )}
                                            </>
                                        )
                                    }

                                    )}
                                </>
                            )
                        })

                        }


                        {/* ======================================== */}
                        {/* <br />
                        <br />
                        <br />
                        <br />
                        <tr>
                            <td colspan="7" className='role_module'>Sold To Management</td>

                        </tr>
                        <tr>
                            <td></td>
                            <td>Main Page</td>
                            <td></td>
                            <td>
                                <FormControlLabel control={<Checkbox disabled defaultChecked />} />
                            </td>
                            <td>
                                <FormControlLabel control={<Checkbox disabled defaultChecked />} />
                            </td>
                            <td>
                                <FormControlLabel control={<Checkbox disabled defaultChecked />} />
                            </td>
                            <td>
                                <FormControlLabel control={<Checkbox disabled defaultChecked={false} />} />
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td>Assign Prod Group</td>
                            <td>
                                <FormControlLabel control={<Checkbox disabled defaultChecked />} />
                            </td>
                            <td>
                                <FormControlLabel control={<Checkbox disabled defaultChecked />} />
                            </td>
                            <td>
                                <FormControlLabel control={<Checkbox disabled defaultChecked={false} />} />
                            </td>
                            <td>
                                <FormControlLabel control={<Checkbox disabled defaultChecked={false} />} />
                            </td>
                        </tr>

                        <tr>
                            <td></td>
                            <td>Sales Area List</td>
                            <td></td>
                            <td>
                                <FormControlLabel control={<Checkbox disabled defaultChecked />} />
                            </td>
                            <td>
                                <FormControlLabel control={<Checkbox disabled defaultChecked />} />
                            </td>
                            <td>
                                <FormControlLabel control={<Checkbox disabled defaultChecked={false} />} />
                            </td>
                            <td>
                                <FormControlLabel control={<Checkbox disabled defaultChecked />} />
                            </td>
                        </tr>


                        <tr>
                            <td colspan="7" className='role_module'>Banner Image</td>

                        </tr>
                        <tr>
                            <td></td>
                            <td>Main Page</td>
                            <td></td>
                            <td>
                                <FormControlLabel control={<Checkbox disabled defaultChecked />} />
                            </td>
                            <td>
                                <FormControlLabel control={<Checkbox disabled defaultChecked={false} />} />
                            </td>
                            <td>
                                <FormControlLabel control={<Checkbox disabled defaultChecked={false} />} />
                            </td>
                            <td>
                                <FormControlLabel control={<Checkbox disabled defaultChecked={false} />} />
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td>Add Banner</td>
                            <td>
                                <FormControlLabel control={<Checkbox disabled defaultChecked />} />
                            </td>
                            <td>
                                <FormControlLabel control={<Checkbox disabled defaultChecked />} />
                            </td>
                            <td>
                                <FormControlLabel control={<Checkbox disabled defaultChecked={false} />} />
                            </td>
                            <td>
                                <FormControlLabel control={<Checkbox disabled defaultChecked={false} />} />
                            </td>
                        </tr>

                        <tr>
                            <td colspan="7" className='role_module'>Product Master</td>

                        </tr>
                        <tr>
                            <td></td>
                            <td>Main Page</td>
                            <td></td>
                            <td>
                                <FormControlLabel control={<Checkbox disabled defaultChecked />} />
                            </td>
                            <td>
                                <FormControlLabel control={<Checkbox disabled defaultChecked />} />
                            </td>
                            <td>
                                <FormControlLabel control={<Checkbox disabled defaultChecked />} />
                            </td>
                            <td>
                                <FormControlLabel control={<Checkbox disabled defaultChecked />} />
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td>Assign</td>
                            <td>
                                <FormControlLabel control={<Checkbox disabled defaultChecked={false} />} />
                            </td>
                            <td>
                                <FormControlLabel control={<Checkbox disabled defaultChecked={false} />} />
                            </td>
                            <td>
                                <FormControlLabel control={<Checkbox disabled defaultChecked={false} />} />
                            </td>
                            <td>
                                <FormControlLabel control={<Checkbox disabled defaultChecked={false} />} />
                            </td>
                        </tr> */}
                    </tbody>
                </table>
                :
                        <p className='text-center'> Data Not found</p>
                    }


                {/* <div className='row'>
                        <div className='col-12 text-right'>
                            <Button
                                variant="contained"
                                className="btncolor px-5"
                                size="small"
                                sx={{ m: 1 }}
                            >
                                Update
                            </Button>
                        </div>

                    </div> */}

            </>
            {/* } */}


            {/* <div className='row'>
                <div className='col-12 col-sm-6 col-md-4'>
                    <Select
                        label={"Roles"}
                        options={users}
                        minWidth="100%"
                    />
                </div>
            </div>

            <FormGroup>
                <div className='row my-4'>
                    <div className='col-sm-6 col-md-3 col-lg-3'>

                        <FormControlLabel control={<Checkbox disabled defaultChecked />} label="Sold To View" />
                    </div>

                    <div className='col-sm-6 col-md-3 col-lg-3'>
                        <FormControlLabel control={<Checkbox disabled defaultChecked />} label="Sold To Post" />
                    </div>

                    <div className='col-sm-6 col-md-3 col-lg-3'>
                        <FormControlLabel control={<Checkbox disabled defaultChecked />} label="Sold TO Create" />
                    </div>

                    <div className='col-sm-6 col-md-3 col-lg-3'>
                        <FormControlLabel control={<Checkbox disabled defaultChecked />} label="Sold To Delete" />
                    </div>

                    <div className='col-sm-6 col-md-3 col-lg-3'>
                        <FormControlLabel control={<Checkbox disabled defaultChecked />} label="Subdealer View" />
                    </div>

                    <div className='col-sm-6 col-md-3 col-lg-3'>
                        <FormControlLabel control={<Checkbox disabled defaultChecked />} label="Subdelater Create" />
                    </div>

                    <div className='col-sm-6 col-md-3 col-lg-3'>
                        <FormControlLabel control={<Checkbox disabled defaultChecked />} label="Subdealer Update" />
                    </div>

                    <div className='col-sm-6 col-md-3 col-lg-3'>
                        <FormControlLabel control={<Checkbox disabled defaultChecked />} label="Subdealer Delete" />
                    </div>

                    <div className='col-sm-6 col-md-3 col-lg-3'>
                        <FormControlLabel control={<Checkbox disabled defaultChecked />} label="Vehicle Tracking" />
                    </div>

                    <div className='col-12 text-right'>
                        <Button
                            variant="contained"
                            className="btncolor px-5"
                            size="small"
                            sx={{ m: 1 }}
                        //   onClick={}
                        >
                            Save
                        </Button>
                    </div>

                </div>
            </FormGroup> */}

        </div>
    )
}

export default AdminRoles